import * as React from 'react';

import type { SupplierClient } from '@/api/supplier-client';
import { HttpSupplierClient } from '@/api/supplier-client.http';

// =============================================================================
// supplier-client-context.tsx — Injection du SupplierClient (DI seam).
// =============================================================================
// Permet de substituer le client (double déterministe en test, impl HTTP réelle
// plus tard) sans toucher l'UI. Par défaut (Phase 2, D2a-MUT) : l'impl HTTP réelle ;
// le stub reste injectable via le provider en test. Instance partagée (sans état interne).

const defaultSupplierClient: SupplierClient = new HttpSupplierClient();

const SupplierClientContext =
  React.createContext<SupplierClient>(defaultSupplierClient);

export interface SupplierClientProviderProps {
  client?: SupplierClient | undefined;
  children: React.ReactNode;
}

export function SupplierClientProvider({
  client = defaultSupplierClient,
  children,
}: SupplierClientProviderProps): React.JSX.Element {
  return (
    <SupplierClientContext.Provider value={client}>
      {children}
    </SupplierClientContext.Provider>
  );
}

export function useSupplierClient(): SupplierClient {
  return React.useContext(SupplierClientContext);
}
